import { render, staticRenderFns } from "./RegistrarMixer.vue?vue&type=template&id=5b12f330&scoped=true&"
import script from "./RegistrarMixer.vue?vue&type=script&lang=js&"
export * from "./RegistrarMixer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b12f330",
  null
  
)

export default component.exports